import { useEffect, useContext, useState } from 'react';
import OLVectorLayer from "ol/layer/Vector";
import { MapContext } from '../MapProvider';
const VectorLayer = (props) => {
    const { source, style, zIndex = 0, onceChange, minZoom, maxZoom } = props;
    const map = useContext(MapContext);
    const [vectorLayer] = useState(new OLVectorLayer({ source, style, minZoom, maxZoom }));
    useEffect(() => {
        if (!map)
            return;
        map.addLayer(vectorLayer);
        vectorLayer.setZIndex(zIndex);
        return () => {
            if (map) {
                map.removeLayer(vectorLayer);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);
    useEffect(() => {
        if (source)
            vectorLayer.setSource(source);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source]);
    useEffect(() => {
        if (!(map && onceChange))
            return;
        vectorLayer.getSource()?.once("change", function () {
            const extent = vectorLayer.getSource().getExtent();
            onceChange(extent);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, onceChange]);
    useEffect(() => {
        if (minZoom)
            vectorLayer.setMinZoom(minZoom);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minZoom]);
    useEffect(() => {
        if (maxZoom)
            vectorLayer.setMaxZoom(maxZoom);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [maxZoom]);
    return null;
};
export default VectorLayer;
